import {ApplicationRef, ChangeDetectorRef, Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {DeviceDetectorService} from '@common/device-detection/services/device-detector.service';
import {PrintService} from "@feature/_app_modules/printing/services/print.service";
import {BehaviorSubject, Observable, Subject, shareReplay} from 'rxjs';
import {PrintData} from "@feature/_app_modules/printing/printing-types";

@Component({
  selector: 'mojo-dbw-print-btn',
  templateUrl: './dbw-print-btn.component.html'
})
export class DbwPrintBtnComponent implements OnInit {

  @ContentChild(TemplateRef) printTemplate: TemplateRef<any>;

  /**
   * Set the data for the print layout into the event
   * when handling the event
   */
  @Output()
  printDataCallback = new EventEmitter<void>();

  private readonly isPrintingSubject = new BehaviorSubject<boolean>(false);
  isPrinting$ = this.isPrintingSubject.asObservable();
  toolbarDisplayed: boolean;


  constructor(
    private readonly deviceDetectorService: DeviceDetectorService,
    private readonly printService: PrintService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  handlePrintClick() {
    this.printDataCallback.emit();
    this.isPrintingSubject.next(true);
  }


  ngOnInit(): void {
    this.printService.isPrinting$.subscribe(isPrinting => {
      if (!isPrinting) {
        this.isPrintingSubject.next(false);
        //There seems to be an issue with change detection so am manually calling this
        this.changeDetectorRef.detectChanges();
      }
    })
  }

  isMobile(): boolean {
    return this.deviceDetectorService.isMobile() || this.deviceDetectorService.isTablet();
  }

  toggleToolbar() {
    this.toolbarDisplayed = !this.toolbarDisplayed;
  }

}
